import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemAudience } from '../components/ProblemAudience';
import { Features } from '../components/Features';
import { Pricing } from '../components/Pricing';
import { FAQFooter } from '../components/FAQFooter';
import { OfferSelector } from '../components/OfferSelector';
import { PurchaseNotification } from '../components/PurchaseNotification';
export function Home() {
  return <main className="w-full" data-id="element-335">
      <Hero data-id="element-336" />
      <ProblemAudience data-id="element-337" />
      <Features data-id="element-338" />
      <Pricing data-id="element-339" />

      {/* Bottom CTA */}
      <section className="py-12 md:py-20 bg-white border-t border-slate-100" data-id="element-340">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-341">
          <div className="text-center bg-slate-900 rounded-3xl p-6 md:p-16 text-white shadow-2xl relative overflow-hidden" data-id="element-342">
            <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/3 w-48 h-48 md:w-64 md:h-64 bg-brand-500/30 rounded-full blur-3xl" data-id="element-343" />
            <div className="absolute bottom-0 left-0 translate-y-1/2 -translate-x-1/3 w-48 h-48 md:w-64 md:h-64 bg-accent-500/20 rounded-full blur-3xl" data-id="element-344" />

            <div className="relative z-10" data-id="element-345">
              <h2 className="text-2xl md:text-5xl font-extrabold mb-4 md:mb-6" data-id="element-346">
                No dejes pasar esta oportunidad
              </h2>
              <p className="text-base md:text-xl text-slate-300 mb-6 md:mb-8 font-medium" data-id="element-347">
                Termina en
              </p>

              <div className="mb-6 md:mb-8 flex justify-center scale-75 md:scale-100 transform origin-top" data-id="element-348">
                <div className="flex items-center justify-center gap-2 text-xl md:text-2xl font-bold text-slate-900" data-id="element-349">
                  <div className="flex flex-col items-center" data-id="element-350">
                    <div className="bg-white px-2 py-1.5 md:px-3 md:py-2 rounded-lg shadow-sm min-w-[50px] md:min-w-[60px] text-center" data-id="element-351">
                      23
                    </div>
                    <span className="text-[10px] md:text-xs text-slate-400 mt-1 font-medium uppercase tracking-wider" data-id="element-352">
                      Horas
                    </span>
                  </div>
                  <span className="text-slate-400 -mt-4 md:-mt-5" data-id="element-353">:</span>
                  <div className="flex flex-col items-center" data-id="element-354">
                    <div className="bg-white px-2 py-1.5 md:px-3 md:py-2 rounded-lg shadow-sm min-w-[50px] md:min-w-[60px] text-center" data-id="element-355">
                      48
                    </div>
                    <span className="text-[10px] md:text-xs text-slate-400 mt-1 font-medium uppercase tracking-wider" data-id="element-356">
                      Min
                    </span>
                  </div>
                  <span className="text-slate-400 -mt-4 md:-mt-5" data-id="element-357">:</span>
                  <div className="flex flex-col items-center" data-id="element-358">
                    <div className="bg-white px-2 py-1.5 md:px-3 md:py-2 rounded-lg shadow-sm min-w-[50px] md:min-w-[60px] text-center" data-id="element-359">
                      34
                    </div>
                    <span className="text-[10px] md:text-xs text-slate-400 mt-1 font-medium uppercase tracking-wider" data-id="element-360">
                      Seg
                    </span>
                  </div>
                </div>
              </div>

              <OfferSelector variant="dark" data-id="element-361" />
            </div>
          </div>
        </div>
      </section>

      <FAQFooter data-id="element-362" />

      <PurchaseNotification data-id="element-363" />
    </main>;
}